import React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import IndexPage from "./components/IndexPage";
import PrimarySourcePage from "./components/PrimarySourcePage";
import UploadPage from "./components/UploadPage";
import ErrorBoundary from "./components/ErrorBoundary";
import IdentifySpeakers from "./components/IdentifySpeakers";
import { AppBar, Toolbar, Typography, Button, Container } from "@mui/material";
import TrackUploadProgress from "./components/TrackUploadProgress";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  return (
    <ErrorBoundary>
      <AppBar
        position="sticky"
        sx={{
          background: "transparent",
          boxShadow: "none",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          {/* Back button */}
          {location.pathname !== "/" && (
            <Button
              color="primary"
              variant="contained"
              onClick={() => navigate(-1)} // Go to the previous page
              sx={{ marginRight: 2 }}
            >
              Back
            </Button>
          )}

          <Typography
            variant="h6"
            sx={{ flexGrow: 1, cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            {/* Souvenons */}
          </Typography>

          {/* Hide the Upload button if the current path is "/upload" */}
          {location.pathname !== "/upload" && (
            <Button
              color="primary"
              variant="contained"
              onClick={() => navigate("/upload")}
            >
              Upload video, audio, or text
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/primary_source/:id" element={<PrimarySourcePage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/track-progress/:uuid" element={<TrackUploadProgress />} />
        <Route path="/identify-speakers/:uuid" element={<IdentifySpeakers />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
